import { useState, useCallback, useRef } from 'react';
import { listFiles } from '@services/api/r2ApiClient';
import type { DriveItem } from '@/types/file.types';
import type { StorageScope } from '@services/api/apiConfig';

export function useFileList() {
  const [items, setItems] = useState<DriveItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requestIdRef = useRef(0);

  const fetchFiles = useCallback(async (path = '', storageScope?: StorageScope) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    setError(null);
    try {
      const result = await listFiles(path, false, storageScope);
      if (requestId !== requestIdRef.current) return;
      setItems(result.items);
    } catch (err: any) {
      if (requestId !== requestIdRef.current) return;
      setError(err.message);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, []);

  const clearFiles = useCallback(() => {
    requestIdRef.current += 1;
    setItems([]);
    setError(null);
    setLoading(false);
  }, []);

  return { items, loading, error, fetchFiles, clearFiles };
}
